document.addEventListener("DOMContentLoaded", () => {
  const heroProjects = document.querySelector(".projects-hero");
  const heroProject = document.querySelector(".project-hero");
  const backButton = document.getElementById("backButtonProject");

  const FALLBACK_URL = "/projects";

  if (heroProjects) {
    const desktopImg = heroProjects.dataset.imgDesktop;
    const mobileImg = heroProjects.dataset.imgMobile;

    const applyHeroImage = () => {
      const isMobile = window.innerWidth <= 900;
      const currentImg = isMobile ? mobileImg : desktopImg;
      if (currentImg) {
        heroProjects.style.backgroundImage = `url("${currentImg}")`;
      }
    };

    applyHeroImage();
    window.addEventListener("resize", applyHeroImage);
  }

  if (heroProject) {
    const desktopImg = heroProject.dataset.imgDesktop;
    const mobileImg = heroProject.dataset.imgMobile;

    const applyHeroImage = () => {
      const isMobile = window.innerWidth <= 900;
      const currentImg = isMobile ? mobileImg : desktopImg;
      if (currentImg) {
        heroProject.style.backgroundImage = `url("${currentImg}")`;
      }
    };

    applyHeroImage();
    window.addEventListener("resize", applyHeroImage);
  }

  function sameOrigin(url) {
    try {
      return new URL(url).origin === location.origin;
    } catch {
      return false;
    }
  }

  function goBackOrFallback() {
    const before = location.href;
    const ref = document.referrer;

    if (!ref || !sameOrigin(ref)) {
      location.assign(FALLBACK_URL);
      return;
    }

    history.back();
    setTimeout(() => {
      if (location.href === before) {
        location.assign(FALLBACK_URL);
      }
    }, 300);
  }

  if (backButton) {
    backButton.addEventListener("click", goBackOrFallback);
  }

  const rows = document.querySelectorAll(".project-table__row");
  const previewImg = document.getElementById("collection-preview-img");

  if (!rows.length || !previewImg) return;

  const defaultRow = rows[0];
  const defaultImage = defaultRow.dataset.image;

  const setPreviewImage = (url) => {
    if (url) {
      previewImg.src = url;
      previewImg.classList.add("has-image");
    } else {
      previewImg.src = "";
      previewImg.classList.remove("has-image");
    }
  };

  defaultRow.classList.add("is-active");
  setPreviewImage(defaultImage);

  rows.forEach((row) => {
    row.addEventListener("mouseenter", () => {
      rows.forEach((r) => r.classList.remove("is-active"));
      row.classList.add("is-active");
      const imageUrl = row.dataset.image;
      setPreviewImage(imageUrl);
    });

    row.addEventListener("mouseleave", () => {
      rows.forEach((r) => r.classList.remove("is-active"));
      defaultRow.classList.add("is-active");
      setPreviewImage(defaultImage);
    });

    row.addEventListener("click", () => {
      const url = row.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });
});
